import React, { Component } from "react";
import logo from "../../assets/images/logo.png";
import { Button } from "reactstrap";

export default class BannerVideo extends Component {
  render() {
    return (
      <React.Fragment>
        <section
          className="section bg-light"
          id="home"
          style={{
            paddingTop: 0,
            paddingBottom: 0,
            position: "relative",
            minHeight: "100vh",
          }}
        >
          <video
            width="100%"
            height="100%"
            style={{ objectFit: "cover", height: "100vh" }}
            autoPlay
            muted
            loop
          >
            <source src="/assets/banner.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              height: "100%",
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              padding: "20px",
              backgroundColor: "rgba(0,0,0,0.4)",
            }}
          >
            <img src={logo} alt="" height="80" />
            <h1
              className="hero-1-title fw-normal mt-4 mb-4 text-center"
              style={{ color: "#FFFFFF", fontWeight: 900 }}
            >
              YOUR LOCAL SOLAR ENERGY EXPERT
            </h1>
            <Button
              color="primary"
              id="submit"
              name="send"
              className="btn btn-primary f-18"
              style={{ borderRadius: "44px" }}
            >
              Schedule your free consultation
            </Button>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
